import { useLocation } from "components/_hooks/useRouter";
import { scrollToTop } from "helpers/globalObject";
import React, { useEffect } from "react";

/** Scrolls to top on every route change */
export const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [location]);

  return <React.Fragment>{children}</React.Fragment>;
};
